import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { TyresDashboardQueryKeys } from "modules/TyresDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { TyreFormPayload } from "modules/TyresDashboard/components/TyreModal/hooks/useCreateTyreMutation";

export const useUpdateTyreMutation = () =>
  useTypedMutation<TyreFormPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/tyres/update", payload, ENV.carBaseURL);
    },
    onSuccess: payload => {
      const tyres = typedQueryClient.getQueryData(TyresDashboardQueryKeys.tyres);
      if (!tyres?.items) return;

      const tyreIdx = tyres.items.findIndex(tyre => tyre.id === payload.id);
      if (tyreIdx === -1) return;

      typedQueryClient.setQueryData(TyresDashboardQueryKeys.tyres, {
        ...tyres,
        items: tyres.items.with(tyreIdx, { ...tyres.items[tyreIdx], ...payload, updated_on: toISOString(new Date()) })
      });
    }
  });
